// src/Propertylist/DetailModalProperty.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const DetailModalPropertyhead = ({ selectedProperty, currency }) => {
  const { t } = useTranslation(); // ✅ ใช้งานฟังก์ชัน t

  if (!selectedProperty) return null;

  return (
    <div style={{ padding: '10px 0' }}>
      {/* Header */}
      <h2
        style={{
          marginBottom: '2px',
          marginTop: '0px',
          color: '#fff',
          fontSize: '1.6rem',
          fontWeight: '700',
          borderBottom: '2px solid #eee',
          padding: '20px',
          backgroundColor: '#142438',
          borderRadius: '8px',
        }}
      >
        <span style={{ color: 'gold', fontWeight: 'bold', fontSize: '15px'}}>{t('SHA ID')} :</span> <span style={{  fontWeight: 'bold', fontSize: '15px'}}>{selectedProperty.property_id}</span>  <br />
        {selectedProperty.name}
      </h2>

    
         
    </div>
  );
};

export default DetailModalPropertyhead;
